module.exports = __webpack_public_path__ + "img/alcohol-intake-no.7fd5df0e.svg";